<template>
<!-- 设计师 -->
<div class="viewContainer">
  <div v-if="designerList">
    <!-- <p class="region">查询区域</p> -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
      <el-form :inline="true" :model="formInline" class="findform">
        <el-form-item label="设计师名称：" label-width="120px" style="width:100%;display:flex">
          <el-input v-model="designerName" placeholder="请输入设计师名称" maxlength="15"></el-input>
        </el-form-item>
        <el-form-item class="cityname" label="所属城市：" label-width="120px" style="width:100%;display:flex">
          <el-cascader v-model="chengshi" placeholder="请选择城市" :options="options" style="width:100%"
            filterable clearable @change="handleChangeOne"/>
        </el-form-item>
        <el-form-item label="所属店铺：" label-width="120px" style="width:100%;display:flex">
          <el-select v-model="dianpu" placeholder="请选择" filterable>
            <el-option v-for="(item,index) in dianpuArr" :key="index" :value="item.id" :label="item.name"/>
          </el-select>
        </el-form-item>
        <el-form-item label="状态：" label-width="120px" style="width:100%;display:flex">
          <el-select v-model="zhuangtai" placeholder="请选择">
            <el-option v-for="(item,index) in cStatusarr" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="fininfo()">查询</el-button> </el-form-item>
      </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">设计师</p>
        <el-button type="danger" @click="showadd()" style="float: right;margin: 5px 10px 0 0;">新 增</el-button>
      </section>
      <div class="table_container">
      <el-table :data="goodList" stripe border>
        <el-table-column label="序号" type="index" align="center" width="60"/>
        <el-table-column prop="Name" label="设计师" align="center" width="180px">
          <template scope="scope">
            <span class="spanList" :title="scope.row.Name">{{ scope.row.Name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="CPhone" label="所属城市" align="center">
          <template scope="scope">
            <span :title="scope.row.ProvinceName+'-'+scope.row.CityName">{{scope.row.ProvinceName}} - {{scope.row.CityName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Phone" align="center" label="联系电话">
          <template scope="scope">
            <span :title="scope.row.Phone">{{scope.row.Phone}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="DesignerType" label="设计师类型" align="center">
          <template scope="scope">
            <span :title="scope.row.DesignerType">{{scope.row.DesignerType}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="所属店铺" prop="ShopName" align="center">
          <template scope="scope"><span class="spanList" :title="scope.row.ShopName">{{scope.row.ShopName}}</span></template>
        </el-table-column>
        <el-table-column prop="DayCounts" label="当天预约" align="center" width="100px">
          <template scope="scope">{{scope.row.DayCounts}}</template>
        </el-table-column>
        <el-table-column prop="WeekCounts" label="本周预约" align="center" width="100px">
          <template scope="scope">{{scope.row.WeekCounts}}</template>
        </el-table-column>
        <el-table-column prop="MonthCounts" label="本月预约" align="center" width="100px">
          <template scope="scope">{{scope.row.MonthCounts}}</template>
        </el-table-column>
        <el-table-column prop="YearCounts" label="本年预约" align="center" width="100px">
          <template scope="scope">{{scope.row.YearCounts}}</template>
        </el-table-column>
        <el-table-column prop="AllCounts" label="全部预约" align="center" width="100px">
          <template scope="scope">{{scope.row.AllCounts}}</template>
        </el-table-column>
        <el-table-column prop="OnlineStatusName" label="状态" align="center" width="100px">
          <template scope="scope">{{scope.row.OnlineStatusName}}</template>
        </el-table-column>
        <el-table-column prop label="操作" fixed="right" align="center" width="200px">
          <template scope="scope">
            <!-- <el-switch
            v-model="scope.row.IsVerification"
            @change="Authentication(scope)"
            active-color="#F56C6C"
            inactive-color="#ddd"
            inactive-text
            ></el-switch>-->
            <!-- <el-switch v-if="scope.row.IsVerification ==1"
              v-model="scope.row.IsVerification"
              active-color="#F56C6C"
              active-text="认证"
              inactive-color="#ddd"
              @change="Authentication(scope)" inactive-text/>
            <el-switch v-else
              v-model="scope.row.IsVerification"
              active-color="#F56C6C"
              inactive-color="#ddd"
              active-text="认证"
              @change="Authentication(scope)" inactive-text/> -->
            <span @click="showadd(scope.row)" class="handle">
              <i class="el-icon-edit-outline"></i> 编辑
            </span>
            <span @click="over(scope)" class="handle">
              <i :class="scope.row.IsOnline == 1?'el-icon-download':'el-icon-upload2'"></i>
              {{scope.row.IsOnline == 1?'下架':'上架'}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :page-size="10" :current-page="pageIndex" :total="total" style="float:right;margin: 10px 0;"/>
      </div>
    </div>
  </div>
  <div v-else class="main_container">
    <h2 class="shopTitle">设计师基本信息</h2>
    <el-row style="margin: 30px;">
      <el-col :span="11">
        <el-form :model="form" ref="editForm" label-width="130px">
          <el-form-item label="设计师名称：">
            <el-input v-model="sjsName" placeholder="请输入设计师名称" maxlength="10" style="width:60%;"/>
          </el-form-item>
          <el-form-item label="所属城市：">
            <el-cascader v-model="selectedOptions3" placeholder="请选择城市" :options="options"
              style="width:60%;" filterable @change="handleChangeTwo"/>
          </el-form-item>
          <el-form-item label="从业年限：">
            <el-input v-model="WorkTime" placeholder="请输入从业年限" maxlength="2"
              style="width:60%;" onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"/>
            <span style="margin-left:10px">年</span>
          </el-form-item>
          <el-form-item label="设计收费：">
            <el-input v-model="MinDesignPrice" placeholder="最低价位" maxlength="8" :disabled="checked1" style="width:100px"
              @blur="despricebulr" onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"/>
            <span>~</span>
            <el-input v-model="MaxDesignPrice" placeholder="最高价位" maxlength="8" :disabled="checked1" style="width:100px"
              @blur="despricebulr" onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"/>
            <span style="margin-left:5px">元/平米</span>
            <el-checkbox @change="mianyi()" style="margin-left:10px" v-model="checked1">面议</el-checkbox>
          </el-form-item>
          <el-form-item label="专长风格：">
            <span class="choice" @click="choiestyle">选择</span>
            <div v-show="styletrue">
              <span style="color:#F56C6C">已选择：</span>
              <span v-for="(item,index) in styleNamearr" :key="index" style="margin-right:5px;">{{item}}</span>
            </div>
          </el-form-item>
          <el-form-item label="擅长空间：">
            <span @click="choosekong" class="choice">选择</span>
            <!-- <div v-show="isshowbrand">
              <span style="color:#F56C6C">已选择：</span>
              <span v-for="(item,index) in brandNamearr" :key="index" style="margin-right:5px;">{{item}}</span>
            </div>-->
            <div v-show="isshowbrand" style="width:60%;">
              <span style="color:#F56C6C">已选择：</span>
              <span v-for="(item,index) in homenamearr" :key="index" style="margin-right:5px;">{{item}}</span>
            </div>
          </el-form-item>
          <!-- <el-form-item label="承接价位：">
            <el-input v-model="MinAcceptPrice" placeholder="最低价位" maxlength="8" :disabled="checked" style="width:100px"
              @blur="priceblur" onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"/>
            <span>~</span>
            <el-input v-model="MaxAcceptPrice" placeholder="最高价位" maxlength="8" :disabled="checked" style="width:100px"
              @blur="priceblur" onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"/>
            <span style="margin-left:5px">元</span>
            <el-checkbox @change="jiaweichange" style="margin-left:10px" v-model="checked">全部价位</el-checkbox>
          </el-form-item>
          <el-form-item label="承接范围：">
            <span class="choice" @click="choiceRange()">选择</span>
            <div v-show="Rangtrue">
              <span style="color:#F56C6C">已选择：</span>
              <span v-for="(item,index) in RangeName" :key="index" style="margin-right:5px;">{{item}}</span>
            </div>
          </el-form-item> -->
          <el-form-item class="extend" label="个人简介(选填)：">
            <el-input type="textarea" v-model="IntroduceSelf" style="width:60%;" :autosize="{ minRows: 2, maxRows: 6}"
              maxlength="500" show-word-limit placeholder="请输入个人简介："/>
          </el-form-item>
          <el-form-item class="extend" label="设计理念(选填)：">
            <el-input type="textarea" v-model="DesignerIdea" :autosize="{ minRows: 2, maxRows: 6}"
              style="width:60%;" maxlength="20" show-word-limit placeholder="请输入设计理念："/>
          </el-form-item>
          <el-form-item class="extend" label="荣誉奖项(选填)：">
            <el-input type="textarea" v-model="PersonalHonor" style="width:60%;" :autosize="{ minRows: 2, maxRows: 6}"
              maxlength="500" show-word-limit placeholder="请输入荣誉奖项"/>
          </el-form-item>
          <el-form-item label="预约量：">
            <el-input v-model="ReservationCount" placeholder="请输入预约量" maxlength="6" style="width:60%;"
            onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"/>
          </el-form-item>
          <el-form-item label="签单量：">
            <el-input v-model="OrderCount" placeholder="请输入签单量" maxlength="6" style="width:60%;"
            onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"/>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
      <el-form label-width="130px">
        <el-form-item label="设计师电话：">
          <el-input v-model='phone' maxlength="11" placeholder="请输入设计师电话" style="width:60%;"
            onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"/>
        </el-form-item>
        <el-form-item label="设计师头像：">
          <div v-if="LogoUrl" style="width: 88px;position: relative;">
            <img src="../../assets/img/aicon36.png" @click="LogoUrl=''" style="position:absolute;right:0;top:-8px;z-index: 1;width: 20px;"/>
            <el-image :src="LogoUrl" class="avatar" @click="handleClickItem" :preview-src-list="[LogoUrl]"/>
          </div>
          <el-upload class="avatar-uploader" action accept=".png, .jpg" v-else
          :show-file-list="false" :before-upload="beforeAvatarUpload">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="color:#888;">建议尺寸：1比1 ，支持的图片格式，jpg、png。</div>
        </el-form-item>
        <el-form-item label="展示图片：">
        <div style="display:flex;flex-wrap:wrap">
          <div v-for="(item,index) in imgShopArr" :key="index" style="display:inline-block; position: relative;">
            <img src="../../assets/img/aicon36.png" @click="deleteimg(index,item)"
            style="position:absolute;right:6px;top:-8px;cursor: pointer;width: 20px; z-index: 1;"/>
            <el-image :src="item" fit="cover" style="width:80px;height:80px;display:inline-block;margin-right:15px;"/>
          </div>
          <div class="upload" style="display:inline-block;" v-show="imgShopArr.length<5">
            <el-upload v-show="isdisabled" class="avatar-uploader-zstp" style action :show-file-list="false" :before-upload="beforeUploadShopIntroduction">
              <img :src="zstpUrl" v-if="zstpUrl" class="avatar-zstp" style="width:80px;height:80px;"/>
              <i v-else class="el-icon-plus icon-zstp"/>
            </el-upload>
          </div>
        </div>
        <div style="color:#888;">建议尺寸：1200*675，支持的图片格式：jpg、png。</div>
        </el-form-item>
        <el-form-item label="视频（选填）：">
          <div v-if="videoSrc" class="videoClass">
            <span @click="newSeevideo(videoSrc)" class="previewingVideo">
              <img :src="videoImg" v-if="videoImg">
              <img src="../../assets/img/spfm.png" v-else>
              <div class="iconcontainer"><img src="../../assets/img/play.png" class="playIcon"/></div>
            </span>
            <img src="../../assets/img/aicon36.png" @click="delvideo()" v-if="videoSrc" class="chahao"/>
          </div>
          <el-upload v-else class="avatar-uploader activeUploadImg" action="" accept="video/*" :before-upload="handleFile">
            <el-progress type="circle" v-if="videoFlag" :percentage="videoUploadPercent" :width="80" :height="80"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
          <div style="color:#888;">视频格式仅支持: mp4. 视频大小不能超过 50MB !</div>
        </el-form-item>
      </el-form>
      </el-col>
    </el-row>
    <div class="gudingdibu">
      <el-button @click="designerList = true">取消</el-button>
      <el-button type="danger" @click="emit()" :loading="loadingBut">{{loadingButText}}</el-button>
    </div>
  </div>
  <!-- 专长风格弹框 -->
  <el-dialog :title="typeId == 1?'专长风格':'承接范围'" :visible.sync="dialogVisible2" width="900px" :before-close="handleClose2">
    <div class="chooseDia">
      <div class="searchLeft">
        <p style="margin-left:40px;">{{typeId == 1?'请选择专长风格':'请选择承接范围'}}</p>
      </div>
      <div class="searchRight">
        <div class="searchBot">
          <p
            class="Brand"
            style="cursor: pointer;"
            :class="item.checkedBrand==true?'brandColor':''"
            ref="styleName"
            v-for="(item,index) in brandList"
            :key="index"
            @click="choosedBrand(item,index)"
          >{{item.Name}}</p>
          <div v-if="noMore" style="text-align: center;padding-top: 50px;">不好意思，未搜索到此内容</div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align:center;">
      <el-button @click="goReturn2()">取消</el-button>
      <el-button type="danger" @click="sureChoose2()">确认</el-button>
    </div>
  </el-dialog>
  <!-- 专长风格弹框 -->
  <el-dialog title="擅长空间" :visible.sync="centerDialogVisible" width="900px" :before-close="handleClose2">
    <div class="chooseDia">
      <div class="searchLeft">
        <p style="margin-left:40px;">请选择擅长空间</p>
      </div>
      <div class="searchRight">
        <div class="searchTop">
          <span style="font-size:16px;">家装</span>
          <!-- <p>
            <el-checkbox v-model="checkedAll">不限</el-checkbox>
          </p>-->
        </div>
        <div class="searchBot">
          <p
            class="Brand"
            style="cursor: pointer;"
            :class="item.checkedBrand==true?'brandColor':''"
            ref="home"
            v-for="(item,index) in homearr"
            :key="index"
            @click="choosehome(item,index)"
          >{{item.Name}}</p>
          <div v-if="noMore" style="text-align: center;padding-top: 50px;">不好意思，未搜索到此内容</div>
        </div>
        <div style="border-top: 1px solid #f6f6f6;" class="searchTop">
          <span style="font-size:16px;">公装</span>
          <!-- <p>
            <el-checkbox v-model="checkedAll">不限</el-checkbox>
          </p>-->
        </div>
        <div class="searchBot">
          <p
            class="Brand"
            style="cursor: pointer;"
            :class="item.checkedBrand==true?'brandColor':''"
            ref="work"
            v-for="(item,index) in workarr"
            :key="index"
            @click="choosework(item,index)"
          >{{item.Name}}</p>
          <div v-if="noMore" style="text-align: center;padding-top: 50px;">不好意思，未搜索到此内容</div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align:center;">
      <el-button @click="centerDialogVisible = false">取消</el-button>
      <el-button type="danger" @click="centerDialogVisible = false">确认</el-button>
    </div>
  </el-dialog>
  <!-- 完工 -->
  <el-dialog title="提示" :visible.sync="wangong" width="30%">
    <div style="text-align:center;margin-top:50px">{{IsOnline == 1?'确定下架此条信息':'确定上架此条信息'}}</div>
    <div slot="footer" style="margin-top:50px" class="dialog-footer">
      <el-button type="danger" @click="makeover()">确 定</el-button>
      <el-button @click="wangong = false">取 消</el-button>
    </div>
  </el-dialog>
  <!-- 视频播放 -->
  <el-dialog :visible.sync="videoVisible" @close="closeVideo" width="30%" center>
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>
  <!-- 选择装修公司 -->
  <el-dialog title="选择装修公司" :visible.sync="dialogVisibleadd" width="25%" center>
    <el-form>
      <el-form-item label="装修公司：" style="display:flex;">
        <el-select v-model="DesId" filterable placeholder="请选择装修公司" style="width: 90%;">
          <el-option v-for="item in options1" :key="item.shopid" :label="item.shopname" :value="item.shopid"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisibleadd = false">取 消</el-button>
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, postAddFile, provincegetcountys, uploadVedio,userIdentity } from '../../api/newOss';
import { getkind, SelectDesignerList, EditDesignerIsOnlineOrIsCertificatedOrCompleteByOperType,
  CheckDeginerPhoneIsExsist, SelectDesignerSkilledDoMainBaseData} from "../../api/api";
import { addinfo, getinfo, updateinfo, getshoplist } from "../../api/shopWindow";
export default {
  name: "listdes",
  mixins: [alertTrends],
  data() {
    return {
      designerList: true, // 列表页显示
      DesId: "", // 店铺id
      options1:[],
      dialogVisibleadd:false, // 选择装修公司
      show3: true,
      optionsindex: 0,
      options: [
        {
          value: 0,
          label: "全部"
        }
      ],
      infoId: "",
      wangong: false, // 完工
      IsOnline: 0,
      dianpu: '', // 所属店铺
      dianpuArr: [],
      zhuangtai: -1, // 状态
      cStatusarr: [
        {
          Id: -1,
          Name: "全部"
        },
        {
          Id: 0,
          Name: "已下架"
        },
        {
          Id: 1,
          Name: "已上架"
        }
      ],
      check: 1,
      phone:"",
      overtype: true,
      // 检索区域
      designerName: "",
      chengshi: "",
      dialogVisible1: false,
      total: 10,
      remark: "",
      goodList: [],
      shopinfo: "",
      shopinfoId: "",
      goodsName: "",
      pageIndex: 1,
      pageSize: 10,
      brandTypeId: 0,
      brandId: 0,
      cStatus: 0,
      cPhone: "",
      cName: "",
      dialogVisible: false,
      operType: false,
      formInline: {},
      pinpaiptions: [],
      isaddshow:false,
      homearr: [],
      workarr: [],
      centerDialogVisible: false,
      styletrue: false,
      ishow: true,
      stylearr: [],
      styleNamearr: [],
      noMore: false,
      searchCon: "",
      typeId: 1,
      dialogVisible2: false,
      checked1: false,
      StyleIds: [],
      DomainIds: [],
      homenamearr: [],
      IsAllPrice: 0,
      MinAcceptPrice: "",
      MaxAcceptPrice: "",
      RangeIds: [],
      RangeName: [],
      Rangtrue: false,
      isinterview: 0,
      sjsName: '', // 设计师名称
      MinDesignPrice: '', // 设计费用-最低价位
      MaxDesignPrice: '', // 设计费用-最高价位
      ReservationCount: 0, // 预约数量
      OrderCount: 0, // 订单数量
      form: {},
      LogoUrl: "",
      LogoUrl1:"",
      LogoUrl2:"",
      isshowbrandType: false,
      isshowbrand: false,
      checked: false,
      brandNamearr: [],
      brandTypeNamearr: [],
      brandList: [],
      tableName: "tBD柜_风格",
      selectedOptions3: [],
      options: [],
      shengId: 0,
      shiId: 0,
      provinceId: 0,
      cityId: 0,
      WorkTime: "", // 从业年限
      IntroduceSelf: "", // 个人简介
      DesignerIdea: "", // 设计理念
      PersonalHonor: "", // 荣誉奖项
      imgShopArr: [], // 展示图片
      onePic: [],
      isdisabled: true,
      zstpUrl: '', // 展示图片
      
      videoImg: '', // 视频封面图
      videoSrc: "", // 视频-全连接
      videoShortSrc: "", // 视频-切割之后链接
      videoFlag: false, // 进度条显隐
      videoUploadPercent: 0, // 圆形进度条
      videoVisible: false, // 视频播放
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      loadingBut: false,
      loadingButText: '确定',
      
    };
  },
  methods: {
    // 获取设计师列表
    init() {
      var obj = {
        userId: localStorage.Id,
        name: this.designerName, // 设计师名称
        provinceId: this.shengId,
        cityId: this.shiId,
        sreachBbid: this.dianpu, // 所属店铺
        isOnline: this.zhuangtai, // 状态
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      SelectDesignerList(obj).then(data => {
        if (data.ResultCode == 1) {
          this.goodList = data.ResultObj;
          for (var i = 0; i < this.goodList.length; i++) {
            if (this.goodList[i].IsVerification == 1) {
              this.goodList[i].IsVerification = true;
            } else {
              this.goodList[i].IsVerification = false;
            }
          }
          this.total = data.RowsCount;
        } else {
          this.goodList = [];
          this.pageIndex = 1;
          this.total = data.RowsCount;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    // 新增&编辑
    showadd(row){
      if (row) {
        this.DesId = row.DesignerId;
        this.designerList = false;
        this.isaddshow = false;
        // 回显 - 查看详情
        let obj = {
          designerId: this.DesId
        };
        getinfo(obj).then(data => {
          if (data.resultCode == 1) {
            let desInfo = data.resultObj;
            this.sjsName = desInfo.designername; // 设计师名称
            this.phone = desInfo.phone; // 设计师电话
            this.provinceId = desInfo.provinceid;
            this.cityId = desInfo.cityid;
            this.selectedOptions3 = [ this.provinceId, this.cityId ]; // 所在城市
            this.WorkTime = desInfo.worktime; // 从业年限
            // 是否面议 0=否 1=是
            if (desInfo.isinterview == 1) {
              this.checked1 = true;
            } else {
              this.checked1 = false;
              this.MinDesignPrice = desInfo.mindesignprice; // 设计费用-最低价位
              this.MaxDesignPrice = desInfo.maxdesignprice; // 设计费用-最高价位
            }
            // 专长风格
            if (desInfo.styleids + "" != "null") {
              this.StyleIds = desInfo.styleids.split(",");
            }
            if (desInfo.stylename + "" != "null") {
              this.styleNamearr = desInfo.stylename.split(",");
              this.styletrue = true;
            }
            // 擅长空间
            this.DomainIds = [];
            this.homenamearr = [];
            // this.DomainIds = desInfo.DomainIds.split(",");
            if (desInfo.domainids + "" != "null") {
              var arr = desInfo.domainids.split(",");
              for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split("|");
                this.DomainIds.push(arr2[0]);
              }
            }
            if (desInfo.domain + "" != "null") {
              this.homenamearr = desInfo.domain.split(",");
              this.isshowbrand = true;
            }
            this.IntroduceSelf = desInfo.introduceself; // 个人简介
            this.DesignerIdea = desInfo.designeridea; // 设计理念
            this.PersonalHonor = desInfo.personalhonor; // 荣誉奖项
            this.ReservationCount = desInfo.reservationcount; // 预约量
            this.OrderCount = desInfo.ordercount; // 签单量
            this.LogoUrl =   desInfo.faceurl; // 设计师头像 完整路径
            this.imgShopArr = desInfo.designerimages; // 展示图片集合
            // this.videoSrc = desInfo.videourl?localStorage.BaseOssUrl + desInfo.videourl:''; // 视频-长
            // this.videoShortSrc = desInfo.videoUrl?desInfo.videourl:''; // 视频-短
            this.videoSrc = desInfo.videourl; // 视频
            
            // 承接范围
            // if (desInfo.RangeIds + "" != "null") {
            //   this.RangeIds = desInfo.RangeIds.split(",");
            // }
            // if (desInfo.Range + "" != "null") {
            //   this.RangeName = desInfo.Range.split(",");
            //   this.Rangtrue = true;
            // }
            // if (desInfo.IsAllPrice == 1) {
            //   this.checked = true;
            // } else {
            //   this.checked = false;
            //   this.MinAcceptPrice = desInfo.MinAcceptPrice; // 最小承接价位
            //   this.MaxAcceptPrice = desInfo.MaxAcceptPrice; // 最大承接价位
            // }
            // if (desInfo.FaceUrl + "" != "null") {
            //   var that = this;
            //   window.URL = window.URL || window.webkitURL;
            //   var xhr = new XMLHttpRequest();
            //   xhr.open("get", that.desInfo.FaceUrl, true);
            //   xhr.responseType = "blob";
            //   xhr.onload = function() {
            //     //得到一个blob对象
            //     var blob = this.response;
            //     let oFileReader = new FileReader();
            //     oFileReader.onloadend = function(e) {
            //       that.LogoUrl = e.target.result;
            //     };
            //     oFileReader.readAsDataURL(blob);

            //     let src = window.URL.createObjectURL(blob);
            //   };
            //   xhr.send();
            // }
          }
        });
      }else{
        // 获取装修公司店铺列表
        getshoplist('',localStorage.Id).then(data=>{
          if(data.resultCode == 1){
            if(data.resultObj.length>1){
              this.dialogVisibleadd = true;
              this.options1 = data.resultObj;
            } else { // 默认选中第一个店铺不显示弹框
              this.dialogVisibleadd = false;
              this.DesId = data.resultObj[0].shopid; // 店铺id
              this.gonext();
            }
          }else{
            this.showAlert('请先在店铺信息功能中创建自己店铺');
            return false;
          }
        });
      }
    },
    // 确定
    gonext(){
      console.log(this.DesId)
      if(this.DesId === ""){
        this.showAlert('请选择装修公司');
        return false;
      }
      this.dialogVisibleadd = false;
      this.designerList=false;
      this.isaddshow = true;
      this.sjsName = '';
      this.selectedOptions3 = '';
      this.WorkTime = '';
      this.MinDesignPrice = '';
      this.MaxDesignPrice = '';
      this.IntroduceSelf = '';
      this.DesignerIdea = '';
      this.PersonalHonor = '';
      this.ReservationCount = '';
      this.OrderCount = '';
      this.phone = ''; // 设计师电话
      this.LogoUrl = ''; // 设计师头像
      this.imgShopArr = []; // 展示图片集合
      this.videoSrc = ''; // 视频
      
      this.styletrue = false;
      this.styleNamearr=[]; // 专长风格
      this.StyleIds = [];
      this.isshowbrand = false;
      this.homenamearr=[]; // 擅长空间
      this.DomainIds = [];
      
    },
    swal() {
      this.$swal({
        type: "error",
        text: "是否删除当前客户?",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        console.log(res);
      });
    },
    // 查询列表所在城市
    handleChangeOne(val) {
      this.shengId = val[0];
      this.shiId = val[1];
    },
    // 请选择省市
    handleChangeTwo(val) {
      this.provinceId = val[0]; // 省
      this.cityId = val[1]; // 市
    },
    // 查找省市
    getprovince() {
      let loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.resultObj.forEach(item => {
          // 省
          let provinceData = {value:item.pid,label:item.pname,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 市
          item.citys.map(city => {
            let cityData = {value:city.cid, label:city.cname};
            provinceData.children.push(cityData);
          })
        });
        that.options = provinceAndCityAndarea;
      })
    },
    renzheng(scope) {
      this.Authentication(scope);
    },
    // 重置
    fnReset() {
      this.designerName = "";
      this.chengshi = "";
      this.shengId = 0;
      this.shiId = 0;
      this.dianpu = '';
      this.zhuangtai = -1;
      // this.pageIndex = 1;
      // this.init();
    },
    // 查询
    fininfo() {
      this.pageIndex = 1;
      this.init();
    },
    makeover() {
      if (this.overtype) {
        this.overtype = false;
        var obj = {
          userId: localStorage.Id,
          id: this.infoId,
          operType: 1
        };
        EditDesignerIsOnlineOrIsCertificatedOrCompleteByOperType(obj).then(data => {
          this.centerDialogVisible = false;
          if (data.ResultCode == 1) {
            this.init();
            this.showAlert('操作成功', 'success');
          }
        });
      }
    },
    over(scope) {
      this.infoId = scope.row.Id;
      this.IsOnline = scope.row.IsOnline;
      this.overtype = true;
      // this.centerDialogVisible = true;
      this.$swal({
        type: "warning",
        text: this.IsOnline == 1 ? "确定下架此条信息" : "确定上架此条信息",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        if (res.value) {
          this.makeover();
        }
      });
    },
    //认证
    Authentication(scope) {
      let obj = {
        userId: localStorage.Id,
        id: scope.row.Id,
        operType: 3
      };
      EditDesignerIsOnlineOrIsCertificatedOrCompleteByOperType(obj).then(data => {
        this.init();
        console.log(data);
      });
    },
    // 所属店铺
    suoshudianpu(){
      let obj = {
        userId:localStorage.Id,
        dcName:"",
        shoptyp: 2,
      }
      userIdentity(obj).then(data=>{
        if(data.resultCode == 1){
           this.dianpuArr = data.resultObj;
        }
      })
    },
    handleClose() {
      this.remark = "";
      this.dialogVisible = false;
    },

    // 点击保存
    emit() {
      if (this.checked) {
        this.IsAllPrice = 1;
        this.MinAcceptPrice = 0;
        this.MaxAcceptPrice = 0;
      } else {
        this.IsAllPrice = 0;
      }
      if (this.checked1) {
        this.isinterview = 1;
        this.MinDesignPrice = 0;
        this.MaxDesignPrice = 0;
      } else {
        this.isinterview = 0;
      }
      if (this.sjsName == "") {
        this.showAlert('请输入设计师名称');
        return false;
      }
      if (this.provinceId == 0) {
        this.showAlert('请选择所在城市');
        return false;
      }
      if (this.WorkTime == "") {
        this.showAlert('请输入从业年限');
        return false;
      }
      if (this.StyleIds.length == 0) {
        this.showAlert('请选择专长风格');
        return false;
      }
      if (this.DomainIds.length == 0) {
        this.showAlert('请选择擅长空间');
        return false;
      }
      // if (!this.checked) {
      //   if (this.MinAcceptPrice == "") {
      //     this.showAlert('请输入最小承接价位');
      //     return false;
      //   } else if (this.MinAcceptPrice == 0) {
      //     this.showAlert('请输入正确的最小承接价位');
      //     return false;
      //   } else if (this.MaxAcceptPrice == "") {
      //     this.showAlert('请输入最大承接价位');
      //     return false;
      //   } else if (this.MaxAcceptPrice == 0) {
      //     this.showAlert('请输入正确的最大承接价位');
      //     return false;
      //   }
      // }
      // if (this.RangeIds.length == 0) {
      //   this.showAlert('请选择承接范围');
      //   return false;
      // }
      if (!this.checked1) {
        if (this.MinDesignPrice == "") {
          this.showAlert('请输入最小设计收费');
          return false;
        } else if (this.MinDesignPrice == 0) {
          this.showAlert('请输入正确的最小设计收费');
          return false;
        } else if (this.MaxDesignPrice == "") {
          this.showAlert('请输入最大设计收费');
          return false;
        } else if (this.MaxDesignPrice == 0) {
          this.showAlert('请输入正确的最大设计收费');
          return false;
        }
      }
      if(this.phone == ""){
        this.showAlert('请输入设计师电话');
        return false;
      }
      // if(/^1[3456789]\d{9}$/.test(this.phone) == false){
      //    this.showAlert('请输入正确的联系电话');
      //   return false;
      // }
      // this.phoneishave();
      if (this.LogoUrl == "") {
        this.showAlert('请上传设计师头像');
        return false;
      }
      if(this.imgShopArr.length == 0){
        this.showAlert('请至少上传一张展示图片');
        return false;
      }
      if(this.isEdit==true) {
        this.loadingBut = true;
        this.loadingButText = '提交中...';
        return false;
      }
      if(this.isaddshow){
        var obj = {
          operatorid: localStorage.Id, // 操作人ID
          shopId: this.DesId, // 店铺ID
          phone: this.phone, // 设计师手机号
          designername: this.sjsName, // 设计师名称
          provinceid: this.provinceId, // 省
          cityid: this.cityId, // 市
          worktime: this.WorkTime, // 从业年限
          mindesignprice: Number(this.MinDesignPrice), // 设计费用-最低价位
          maxdesignprice: Number(this.MaxDesignPrice), // 设计费用-最高价位
          isinterview: this.isinterview, // 是否面议  0=否 1=是
          styleids: this.StyleIds.join(","), // 专长风格
          domainids: this.DomainIds.join(","), // 擅长空间
          introduceself: this.IntroduceSelf, // 个人简介
          designeridea: this.DesignerIdea, // 设计理念
          personalhonor: this.PersonalHonor, // 荣誉奖项
          reservationcount: !Number(this.ReservationCount)?0:Number(this.ReservationCount), // 预约量
          ordercount: !Number(this.OrderCount)?0:Number(this.OrderCount), // 签单量
          faceurl: this.LogoUrl, // 设计师头像
          designerimages: this.imgShopArr.map(item => item.replace(localStorage.BaseOssUrl, '')).join(","), // 展示图片集合
          videourl: this.videoShortSrc, // 视频（不要前缀）
          
          // MinAcceptPrice:this.MinAcceptPrice,
          // MaxAcceptPrice:this.MaxAcceptPrice,
          // rangeIds:this.RangeIds.join(","),
        }
        addinfo(obj).then(data=>{
          if (data.resultCode == 1) {
            this.isaddshow = false;
            this.showAlert(data.resultMsg, 'success');
            this.loadingBut = false;
            this.loadingButText = '确定';
            this.designerList = true;
            this.init();
          }
        })
      }else{
        let obj = {
          designerid: this.DesId,
          operatorid: localStorage.Id, // 操作人ID
          phone: this.phone, // 设计师手机号
          designername: this.sjsName, // 设计师名称
          provinceid: this.provinceId, // 省
          cityid: this.cityId, // 市
          worktime: this.WorkTime, // 从业年限
          mindesignprice: this.MinDesignPrice, // 设计费用-最低价位
          maxdesignprice: this.MaxDesignPrice, // 设计费用-最高价位
          isinterview: this.isinterview, // 是否面议  0=否 1=是
          styleids: this.StyleIds.join(","), // 专长风格
          domainids: this.DomainIds.join(","), // 擅长空间
          introduceself: this.IntroduceSelf, // 个人简介
          designeridea: this.DesignerIdea, // 设计理念
          personalhonor: this.PersonalHonor, // 荣誉奖项
          reservationcount: !Number(this.ReservationCount)?0:Number(this.ReservationCount), // 预约量
          ordercount: !Number(this.OrderCount)?0:Number(this.OrderCount), // 签单量
          faceurl: this.LogoUrl, // 设计师头像
          designerimages: this.imgShopArr.map(item => item.replace(localStorage.BaseOssUrl, '')).join(","), // 展示图片集合
          videourl: this.videoShortSrc, // 视频（不要前缀）
          
          // IsAllPrice: this.IsAllPrice,
          // MinAcceptPrice: this.MinAcceptPrice,
          // MaxAcceptPrice: this.MaxAcceptPrice,
          // RangeIds: this.RangeIds.join(","),
        };
        updateinfo(obj).then(data => {
          if (data.resultCode == 1) {
            this.showAlert(data.resultMsg, 'success');
          }
          this.loadingBut = false;
          this.loadingButText = '确定';
          this.designerList = true;
          this.init();
        });
      }
    },
    // 检查设计师手机号是否存在
    phoneishave(){
      var obj = {
       phone:this.phone
      }
      CheckDeginerPhoneIsExsist(obj).then(data=>{
        if(data.ResultCode == 1){
          localStorage.dcId = this.DesId
          localStorage.dPhone = this.phone
          // this.$router.push({
          //   path:"/designerList",
          //   query:{
          //     type:1,
          //     Id:0,
          //   }
          // })
          // this.DesId = ""
          // this.phone = ""
          // this.dialogVisibleadd = false
        }
      })
    },
    mianyi() {
      if (this.checked1) {
        this.MinDesignPrice = ''; // 设计费用-最低价位
        this.MaxDesignPrice = ''; // 设计费用-最高价位
      }
    },
    jiaweichange() {
      if (this.checked) {
        this.MinAcceptPrice = "";
        this.MaxAcceptPrice = "";
      }
    },
    // 擅长空间-选择
    choosekong() {
      this.centerDialogVisible = true;
      // 获取风格列表
      this.homearr = [];
      this.workarr = [];
      var obj = {};
      SelectDesignerSkilledDoMainBaseData(obj).then(data => {
        if (data.ResultCode == 1) {
          for (var i = 0; i < data.ResultObj.length; i++) {
            if (data.ResultObj[i].DomainType == 0) {
              this.homearr.push(data.ResultObj[i]);
              this.$nextTick(() => {
                for (var i = 0; i < this.$refs.home.length; i++) {
                  this.$refs.home[i].style.color = "#606266";
                  this.$refs.home[i].style.background = "#f0f0f0";
                }
                for (var i = 0; i < this.homearr.length; i++) {
                  for (var k = 0; k < this.DomainIds.length; k++) {
                    if (this.homearr[i].Id == this.DomainIds[k]) {
                      //           this.$nextTick(() => {
                      this.$refs.home[i].style.color = "#fff";
                      this.$refs.home[i].style.background = "#F56C6C";
                      // })
                    }
                  }
                }
              });
            } else {
              this.workarr.push(data.ResultObj[i]);
              this.$nextTick(() => {
                for (var i = 0; i < this.$refs.work.length; i++) {
                  this.$refs.work[i].style.color = "#606266";
                  this.$refs.work[i].style.background = "#f0f0f0";
                }
                for (var i = 0; i < this.workarr.length; i++) {
                  for (var k = 0; k < this.DomainIds.length; k++) {
                    if (this.workarr[i].Id == this.DomainIds[k]) {
                      //           this.$nextTick(() => {
                      this.$refs.work[i].style.color = "#fff";
                      this.$refs.work[i].style.background = "#F56C6C";
                      // })
                    }
                  }
                }
              });
            }
          }
        }
      });
    },
    changeshow(item) {
      this.ishow = item;
    },
    choosehome(item, index) {
      if (this.DomainIds.indexOf(String(item.Id)) > -1) {
        this.homenamearr.splice(this.DomainIds.indexOf(String(item.Id)), 1);
        this.DomainIds.splice(this.DomainIds.indexOf(String(item.Id)), 1);
        this.$refs.home[index].style.color = "#606266";
        this.$refs.home[index].style.background = "#f0f0f0";
        if (this.homenamearr.length == 0) {
          this.isshowbrand = false;
        }
      } else {
        this.isshowbrand = true;
        this.homenamearr.push(item.Name);
        this.DomainIds.push(String(item.Id));
        this.$refs.home[index].style.color = "#fff";
        this.$refs.home[index].style.background = "#F56C6C";
      }
    },
    choosework(item, index) {
      if (this.DomainIds.indexOf(String(item.Id)) > -1) {
        this.homenamearr.splice(this.DomainIds.indexOf(String(item.Id)), 1);
        this.DomainIds.splice(this.DomainIds.indexOf(String(item.Id)), 1);
        this.$refs.work[index].style.color = "#606266";
        this.$refs.work[index].style.background = "#f0f0f0";
        if (this.homenamearr.length == 0) {
          this.isshowbrand = false;
        }
      } else {
        this.isshowbrand = true;
        this.homenamearr.push(item.Name);
        this.DomainIds.push(String(item.Id));
        this.$refs.work[index].style.color = "#fff";
        this.$refs.work[index].style.background = "#F56C6C";
      }
    },
    //点击品牌品类
    choosedBrand(item, index) {
      if (this.tableName == "tBD柜_风格") {
        if (this.StyleIds.indexOf(String(item.Id)) > -1) {
          this.styleNamearr.splice(this.StyleIds.indexOf(String(item.Id)), 1);
          this.StyleIds.splice(this.StyleIds.indexOf(String(item.Id)), 1);
          this.$refs.styleName[index].style.color = "#606266";
          this.$refs.styleName[index].style.background = "#f0f0f0";
          if (this.styleNamearr.length == 0) {
            this.styletrue = false;
          }
        } else {
          this.styletrue = true;
          this.styleNamearr.push(item.Name);
          this.StyleIds.push(String(item.Id));
          this.$refs.styleName[index].style.color = "#fff";
          this.$refs.styleName[index].style.background = "#F56C6C";
        }
      } else {
        if (this.RangeIds.indexOf(String(item.Id)) > -1) {
          this.RangeName.splice(this.RangeIds.indexOf(String(item.Id)), 1);
          this.RangeIds.splice(this.RangeIds.indexOf(String(item.Id)), 1);
          this.$refs.styleName[index].style.color = "#606266";
          this.$refs.styleName[index].style.background = "#f0f0f0";
          if (this.RangeName.length == 0) {
            this.Rangtrue = false;
          }
        } else {
          this.Rangtrue = true;
          this.RangeName.push(item.Name);
          this.RangeIds.push(String(item.Id));
          this.$refs.styleName[index].style.color = "#fff";
          this.$refs.styleName[index].style.background = "#F56C6C";
        }
      }
    },
    sureChoose2() {
      this.dialogVisible2 = false;
    },
    goReturn2() {
      this.dialogVisible2 = false;
    },
    letterDia() {
      this.getstyle();
    },
    handleClose2() {
      this.centerDialogVisible = false;
      this.dialogVisible2 = false;
    },
    choiestyle() {
      this.typeId = 1;
      this.tableName = "tBD柜_风格";
      this.getstyle();
      this.dialogVisible2 = true;
    },
    choiceRange() {
      this.typeId = 2;
      this.tableName = "tBDBearRange";
      this.getstyle();
      this.dialogVisible2 = true;
    },
    //获取风格列表
    getstyle() {
      var obj = {
        tableName: this.tableName,
        keyWord: this.searchCon,
        parentId: ""
      };
      getkind(obj).then(data => {
        if (data.ResultCode == 1) {
          this.brandList = data.ResultObj;
          this.$nextTick(() => {
            for (var i = 0; i < this.$refs.styleName.length; i++) {
              this.$refs.styleName[i].style.color = "#606266";
              this.$refs.styleName[i].style.background = "#f0f0f0";
            }
            if (this.typeId == 1) {
              for (var i = 0; i < this.brandList.length; i++) {
                for (var k = 0; k < this.StyleIds.length; k++) {
                  if (this.brandList[i].Id == this.StyleIds[k]) {
                    //           this.$nextTick(() => {
                    this.$refs.styleName[i].style.color = "#fff";
                    this.$refs.styleName[i].style.background = "#F56C6C";
                    // })
                  }
                }
              }
            } else {
              for (var i = 0; i < this.brandList.length; i++) {
                for (var k = 0; k < this.RangeIds.length; k++) {
                  if (this.brandList[i].Id == this.RangeIds[k]) {
                    //           this.$nextTick(() => {
                    this.$refs.styleName[i].style.color = "#fff";
                    this.$refs.styleName[i].style.background = "#F56C6C";
                    // })
                  }
                }
              }
            }
          });
        } else {
          this.brandList = [];
        }
      });
    },
    despricebulr() {
      if (this.MaxDesignPrice != "") {
        if (Number(this.MaxDesignPrice) - Number(this.MinDesignPrice) <= 0) {
          this.MaxDesignPrice = "";
          this.showAlert('设计收费最大值应大于最小值');
        }
      }
    },
    priceblur() {
      if (this.MaxAcceptPrice != "") {
        if (Number(this.MaxAcceptPrice) - Number(this.MinAcceptPrice) <= 0) {
          this.showAlert('承接价位最大值应大于最小值');
        }
      }
    },
    beforeAvatarUpload(file) {
      const isSize = new Promise(function(resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width / img.height == 1; // 控制传正方形图片
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          var obj = {type: 36};
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
              
            }
          })
          var newOssPic = await uploadOSS(file,0);
          that.LogoUrl = newOssPic;
        };
        return file;
      }, () => {
        this.showAlert('上传图片宽高比例应为1:1');
        return Promise.reject();
      });
      return isSize;
      // var that = this;
      // var reader = new FileReader();
      // reader.readAsDataURL(file);
      // reader.onload = function(e) {
      //   that.LogoUrl = e.target.result;
      // };
      // return file;
    },
    // 展示图片
    beforeUploadShopIntroduction(file) {
      var that = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function(e) {
        /* oss 直传图片 */
        var obj = {type: 38};
        getOssFile(obj).then(data => {
          this.fileName = file.name;
          if (data.resultCode == 1) {
            let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
            let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
            let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
            let ossfile = data.resultObj.directory; // 保存路径
            let ossbucket = data.resultObj.bucket; // bucket
            localStorage.setItem('keyossId',ossId);
            localStorage.setItem('keyossSecret',ossSecret);
            localStorage.setItem('keyossHost',ossHost);
            localStorage.setItem('keyossfile',ossfile);
            localStorage.setItem('keyossbucket',ossbucket);
          }
        })
        var newOssPic = await uploadOSS(file,0);
        that.imgShopArr.push(newOssPic);
        that.imgarrCutting = newOssPic.replace(localStorage.BaseOssUrl,'')

        var obj = {
          name: this.fileName,
          url: that.imgarrCutting,
          uploader: localStorage.Id
        };
        postAddFile(obj).then(data => {
          if (data.resultCode == 1) {
            that.onePic.push(data.resultObj);
          }
        });
      };
      if (that.imgShopArr.length >= 4) {
        that.isdisabled = false;
      }
      return file;
    },
    // 展示图片-del
    deleteimg(index) {
      this.imgShopArr.splice(index, 1);
      this.onePic.splice(index, 1);
      if (this.imgShopArr.length >= 5) {
        this.isdisabled = false;
      } else {
        this.isdisabled = true;
      }
    },
    // 视频
    handleFile(file) {
      if (file.size > 50*1024 * 1024) {
        this.showAlert('请上传小于50MB的视频');
        return false;
      }
      if (file.type.indexOf("mp4") == -1) {
        this.showAlert('请上传mp4格式的视频');
        return false;
      }
      // 正在上传视频中，请稍后再试
      this.loadingBut = true;
      this.loadingButText = '上传中...';
      this.videoFlag = true;
      this.videoUploadPercent = 0;
      this.timer = setInterval(() => {
        if (this.videoUploadPercent >= 99) {
          clearInterval();
          return;
        }
        this.videoUploadPercent += 1;
      }, 50);
      this.videoSrc = "";
      let obj2 = new FormData();
      obj2.append('file',file);
      //上传视频获取路径
      uploadVedio(obj2, 4).then(data=>{
        if(data.resultCode == 1){
          this.videoImg = localStorage.BaseOssUrl + data.resultObj.r_png; // 视频封面图
          this.videoSrc = localStorage.BaseOssUrl + data.resultObj.r_m3u8;
          this.videoShortSrc = this.videoSrc.replace(localStorage.BaseOssUrl,'');
          this.loadingBut = false;
          this.loadingButText = '确定';
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        } else {
          this.showAlert(data.resultMsg, 'error');
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        }
      }).catch(error => {
        this.showAlert('上传失败', 'error');
      });
    },
    // 新版本上传oss预览
    newSeevideo(){
      if(this.videoSrc.indexOf("blob:") != -1){
        window.open(this.videoSrc);
      }else{
        this.palySeevideo(this.videoSrc);
      }
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;
    },
    closeVideo() {
      this.$refs.videoPlayer.player.pause();
    },
    // 删除视频操作
    delvideo() {
      this.$swal({
        type: "warning",
        text: "重要信息，确认删除视频吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.videoImg='';
          this.videoSrc='';
          this.videoShortSrc='';
        }
      }).catch(() => {
        return;
      });
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
  },
  created() {
    this.init();
    this.getprovince(); // 所在城市
    this.suoshudianpu(); // 所属店铺
  },
};
</script>
<style scoped lang="less">
.region {
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 20px;
}
.region1 {
  font-size: 18px;
  font-weight: 600;
}
.ahref {
  color: #040404;
}
.ahref:hover {
  color: #F56C6C;
}


.choice {
  display: inline-block;
  width: 80px;
  height: 40px;
  border: 1px solid #eee;
  color: #888;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.choice:hover {
  border-color: #F56C6C;
  color: #F56C6C;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px solid #eee;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.chooseDia {
  width: 740px;
  height: 365px;
  background: #fff;
  border: 1px solid #f6f6f6;
  font-size: 12px;
  margin: auto;
  .searchLeft {
    float: left;
    width: 140px;
    height: 365px;
    color: #797979;
    padding-top: 30px;
    box-sizing: border-box;
    background: #f5f5f5;
    p {
      margin-bottom: 10px;
    }
  }
  .searchRight {
    width: calc(100% - 140px);
    float: right;
    height: 365px;
    overflow: hidden;
    text-align: left;
    .searchTop {
      padding: 30px 20px 15px 20px;
      box-sizing: border-box;
      border-bottom: 1px solid #f6f6f6;
      overflow: hidden;
      span {
        margin-right: 20px;
      }
      /deep/ .el-input {
        width: 240px;
        height: 35px;
        background: #fff;
        margin-top: -10px;
        float: right;
        .el-input__inner {
          height: 35px;
          border: 1px solid #ededed;
        }
      }
      p {
        margin-top: 20px;
        /deep/ .el-input {
          float: none;
          width: 180px;
          height: 35px;
        }
      }
    }
    .searchBot {
      padding: 20px 20px 30px 20px;
      box-sizing: border-box;
      max-height: 190px;
      min-height: 65px;
      overflow-y: scroll;
      p {
        display: inline-block;
        float: left;
        padding: 8px;
        background: #f0f0f0;
        margin-right: 15px;
        margin-bottom: 15px;
      }
    }
  }
}
.brandColor {
  background: #F56C6C;
  color: #fff;
}
// 展示图片
.avatar-uploader-zstp .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-zstp {
  width: 80px;
  height: 80px;
  display: block;
}
.icon-zstp {
  width: 80px;
  line-height: 80px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  border: 1px solid #eeeeee;
}
</style>


// WEBPACK FOOTER //
// listdes.vue?5b65065a